export default __webpack_public_path__ + "static/media/AstronomyEarth_02.ea194f26.png";